import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { hubAdjustmentRateListTableHeader } from '@/constants/hubManagement/hubList';
import vuexStore from '@/vuex-store';
import { computed, toRefs, } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HubAdjustmentRateList',
    props: {
        items: { default: () => ([]) }
    },
    setup(__props) {
        // component: 정산 비율
        const props = __props;
        const { items } = toRefs(props);
        const isHead = computed(() => vuexStore.getters['user/isHead']);
        const { distributor, hub, } = hubAdjustmentRateListTableHeader;
        const tableHeaderList = isHead.value ? distributor : hub;
        return (_ctx, _cache) => {
            const _component_v_data_table = _resolveComponent("v-data-table");
            return (_openBlock(), _createBlock(_component_v_data_table, {
                hover: "",
                class: "hub-adjustment-rate-list-table brg-table",
                "hide-default-footer": "",
                "item-key": "name",
                "no-data-text": _ctx.$t(`common.no_data_text`),
                items: _unref(items),
                headers: _unref(tableHeaderList)
            }, {
                bottom: _withCtx(() => _cache[0] || (_cache[0] = [])),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["no-data-text", "items", "headers"]));
        };
    }
});
